export default __webpack_public_path__ + "static/media/event_icon.d92772ab.svg";